const VERSION = 'v1.1.2';

export default VERSION;



// WEBPACK FOOTER //
// ../gwi-ads/iab_300x250/src/config/version.js